"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var InboxRuleClause_1 = require("./InboxRuleClause");
var addNewClause_1 = require("../actions/addNewClause");
var getClauseSectionProperties_1 = require("../actions/helpers/getClauseSectionProperties");
var getSectionCompletionStatus_1 = require("../actions/helpers/getSectionCompletionStatus");
var hasUsedAllClauseTypesInSection_1 = require("../actions/helpers/hasUsedAllClauseTypesInSection");
var setClauseErrorText_1 = require("../actions/helpers/setClauseErrorText");
var setFocusedClauseId_1 = require("../actions/helpers/setFocusedClauseId");
var setRuleName_1 = require("../actions/setRuleName");
var store_1 = require("../store/store");
var isValidClause_1 = require("../utils/isValidClause");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var TextField_1 = require("office-ui-fabric-react/lib/TextField");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var styles = require('./InboxRulesSection.scss');
var classNames = require('classnames/bind').bind(styles);
var InboxRulesSectionComputedState = /** @class */ (function () {
    function InboxRulesSectionComputedState(props) {
        this.props = props;
    }
    Object.defineProperty(InboxRulesSectionComputedState.prototype, "sectionCompletionStatus", {
        get: function () {
            return getSectionCompletionStatus_1.default(this.props.sectionType, this.props.clauseIds);
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.computed
    ], InboxRulesSectionComputedState.prototype, "sectionCompletionStatus", null);
    return InboxRulesSectionComputedState;
}());
var InboxRulesSection = /** @class */ (function (_super) {
    tslib_1.__extends(InboxRulesSection, _super);
    function InboxRulesSection(props) {
        var _this = _super.call(this, props) || this;
        _this.setFocusOnNameField = function (shouldSetFocus) {
            setFocusedClauseId_1.default('name', shouldSetFocus);
        };
        _this.validateName = function () {
            setClauseErrorText_1.default('name', store_1.default.inboxRulesEditState.ruleName.trim().length > 0);
            setFocusedClauseId_1.default('name', false);
        };
        _this.computedState = new InboxRulesSectionComputedState(_this.props);
        return _this;
    }
    InboxRulesSection.prototype.render = function () {
        var _this = this;
        var sectionProperties = getClauseSectionProperties_1.default(this.props.sectionType);
        var sectionStatus = this.computedState.sectionCompletionStatus;
        var sectionNumberClassName = classNames(styles.sectionNumber, sectionStatus == 2 /* InProgress */ &&
            styles.inProgressSection, sectionStatus == 0 /* Incomplete */ &&
            styles.incompleteSection, sectionStatus == 1 /* Complete */ && styles.completeSection);
        var showAddException = this.props.sectionType == 'action' &&
            store_1.default.inboxRulesEditState.exceptionClauseIds.length == 0;
        return (React.createElement("div", { className: styles.sectionContainer },
            React.createElement("div", { className: sectionNumberClassName }, sectionStatus == 1 /* Complete */ ? (React.createElement(Icon_1.Icon, { iconName: "CheckMark" /* CheckMark */, className: styles.sectionCompleteCheckmark })) : (this.props.numStep)),
            React.createElement("div", { className: styles.sectionDetails }, this.props.sectionType === 'name' ? (React.createElement("div", { className: styles.ruleNameContainer },
                React.createElement(TextField_1.TextField, { onFocus: function () { return _this.setFocusOnNameField(true); }, onBlur: this.validateName, value: store_1.default.inboxRulesEditState.ruleName, placeholder: 'Name your rule', onChanged: this.onRuleNameInputChanged, errorMessage: store_1.default.inboxRulesEditState.clauseErrorTextMap.get('name') }))) : (React.createElement("div", null,
                this.renderSectionHeader(sectionProperties),
                this.getInboxRuleSectionClauses(sectionProperties),
                showAddException && (React.createElement(Button_1.ActionButton, { className: styles.addAnExceptionButton, onClick: function (evt) {
                        addNewClause_1.default('exception', null, null);
                    }, text: owa_options_strings_1.default.options_inboxRules_addExceptionSection })))))));
    };
    InboxRulesSection.prototype.getInboxRuleSectionClauses = function (sectionProperties) {
        var clauseIds = this.props.clauseIds;
        var clauseTypeOptions = this.props.clauseTypeOptions;
        var sectionType = this.props.sectionType;
        var inboxRuleClauses = [];
        var lastClauseInSection = clauseIds[clauseIds.length - 1];
        for (var i = 0; i < clauseIds.length; i++) {
            var clauseId = clauseIds[i];
            inboxRuleClauses.push(React.createElement(InboxRuleClause_1.default, { key: clauseId, clauseId: clauseId, clauseTypeOptions: clauseTypeOptions, sectionType: sectionType, sectionClauseIds: clauseIds }));
        }
        return (React.createElement("div", { className: styles.inboxRuleClausesContainer },
            inboxRuleClauses,
            this.shouldShowAddNewClause() && (React.createElement(Button_1.ActionButton, { className: styles.addClause, onClick: function (evt) {
                    // validate the previous clause in the section
                    setClauseErrorText_1.default(lastClauseInSection, isValidClause_1.default(lastClauseInSection));
                    addNewClause_1.default(sectionType, null, null);
                }, text: sectionProperties.addClauseText }))));
    };
    InboxRulesSection.prototype.onRuleNameInputChanged = function (inputText) {
        setRuleName_1.default(inputText);
    };
    InboxRulesSection.prototype.shouldShowAddNewClause = function () {
        var clauseIds = this.props.clauseIds;
        var lastClauseInSection = store_1.default.inboxRulesEditState.clauseMap.get(clauseIds[clauseIds.length - 1]);
        // only show add clause button if
        // 1) the last clause in the section has a type
        // 2) user hasn't used all possible clause types yet
        return (lastClauseInSection &&
            lastClauseInSection.clauseType &&
            !hasUsedAllClauseTypesInSection_1.default(this.props.sectionType));
    };
    InboxRulesSection.prototype.renderSectionHeader = function (sectionProperties) {
        return (React.createElement("div", { className: styles.sectionLabel },
            React.createElement("span", null, sectionProperties.headerText)));
    };
    InboxRulesSection = tslib_1.__decorate([
        mobx_react_1.observer
    ], InboxRulesSection);
    return InboxRulesSection;
}(React.Component));
exports.default = InboxRulesSection;
//# sourceMappingURL=InboxRulesSection.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/components/InboxRulesSection.js
// module id = 5184
// module chunks = 2